import React from 'react'
import { Flex, TextInput, Popup } from '@leverege/ui-elements'

export default function FilterInput( props ) {

  const { eventData, value, onChange, searchAsType = true } = props
  const { search, inCustom, inProject, inImagine } = value
  const onEvent = ( evt ) => {
    const data = evt.data
    onChange( {
      value : {
        search : data === 'search' ? evt.value : search, 
        inCustom : data === 'inCustom' ? !inCustom : inCustom, 
        inProject : data === 'inProject' ? !inProject : inProject,
        inImagine : data === 'inImagine' ? !inImagine : inImagine, 
      }, 
      data : eventData } )
  }
  // Add icon 
  return (
    <Flex>
      <Popup title={<i className="fa fa-filter"/>} attachment="top left" targetAttachment="bottom left" >
        <Popup.Item eventData="inCustom" close={false} onClick={onEvent}> <i className={inCustom ? 'fa fa-check fa-fw' : 'fa fa-fw'}/> Custom </Popup.Item>
        <Popup.Item eventData="inProject" close={false} onClick={onEvent}> <i className={inProject ? 'fa fa-check fa-fw' : 'fa fa-fw'}/> Project </Popup.Item>
        <Popup.Item eventData="inImagine" close={false} onClick={onEvent}> <i className={inImagine ? 'fa fa-check fa-fw' : 'fa fa-fw'}/> Imagine </Popup.Item>
      </Popup>
      <TextInput size={40} value={search} eventData="search" onChange={onEvent} changeOnReturn={!searchAsType}/>
    </Flex>
  )
}
